import AnimateNumber from './AnimateNumber'

export default AnimateNumber
